import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Application } from '@softline/application';
import { UiCoreModule } from '@softline/ui-core';

@Component({
  selector: 'soft-app-grid',
  templateUrl: './app-grid.component.html',
  styleUrls: ['./app-grid.component.scss'],
  imports: [CommonModule, UiCoreModule],
})
export class AppGridComponent {
  @Input() application!: Application;
  @Output() navigate = new EventEmitter<Application>();

  goToApplication(application: Application): void {
    this.navigate.emit(application);
  }
}
